export default __webpack_public_path__ + "static/media/Group 12171.afa84c1e.png";